import { defineRoutes } from "@/service/routing/schema";

const base = "/";

export const commonRoutes = defineRoutes({
  homepage: () => `/`,

  privacy_policy: () => "/polityka-prywatnosci",
  cookies_policy: () => "/polityka-cookies",

  user_profile: () => "/profil",
  "advisors.index": () => "/doradcy",
  logout: () => "/logout",
} as const);
